import { PayloadAction } from "@reduxjs/toolkit";
import { NotificationsState } from "../../models/NotificationsState";
import { GetNotificationsPayload } from "../../payload/GetNotifications/GetNotificationsPayload";

const getNotificationsFetch = (state: NotificationsState, action: PayloadAction<GetNotificationsPayload>) => {
    state.isLoading = true;
}

export default getNotificationsFetch;